<template>
  <apexchart
    class="apex-charts"
    :height="chartData.chartOptions.chart.height"
    :width="chartData.chartOptions.chart.width"
    :type="chartData.chartOptions.chart.type"
    :dir="chartData.chartOptions.chart.direction"
    :series="chartData.series"
    :options="chartData.chartOptions"
  ></apexchart>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    chartData: {
      series: {
        type: Array,
        default: [
          {
            name: 'default name',
            data: [100, 0, 2, 1, 5, 4, 8, 7, 25, 554, 98, 65, 32, 54, 21, 54, 98, 56, 23, 12, 45],
          },
        ],
      },
      chartOptions: {
        labels: {
          type: Array,
          default: ['Apple', 'Mango', 'Orange', 'Watermelon'], // be tedade series baraye pie&donat
        },
        chart: {
          type: {
            type: String,
            default: 'area',
          },
          fontFamily: {
            type: String,
            default: "'IRANSans'",
          },
          height: {
            type: Number,
            default: 100,
          },
          width: {
            type: Number || String,
            default: 100,
          },
          sparkline: {
            type: Object,
            default: {
              enabled: false, // use for small areas
            },
          },
          direction: {
            type: String,
            default: 'rtl',
          },
          toolbar: {
            show: {
              type: Boolean,
              default: false,
            },
          },
        },
        dataLabels: {
          enabled: {
            type: Boolean,
            default: false,
          },
        },
        stroke: {
          curve: {
            type: String, //smooth, stepline, straight
            default: 'smooth',
          },
          dashArray: {
            type: Number,
            default: 2,
          },
          width: {
            type: Number,
            default: 2,
          },
        },
        colors: {
          // be tedade series
          type: Array,
          default: ['#50a5f1'],
        },
        fill: {
          type: {
            // 'gradient' / 'solid' / 'pattern' / 'image'
            type: String,
            default: 'gradient',
          },
          gradient: {
            shadeIntensity: {
              type: Number,
              default: 1,
            },
            inverseColors: {
              type: Boolean,
              default: false,
            },
            opacityFrom: {
              type: Number,
              default: 1,
            },
            opacityTo: {
              type: Number,
              default: 1,
            },
            stops: Array,
            shade: {
              type: String,
              default: 'dark',
            },
            type: {
              type: String,
              default: 'horizontal',
            },
            colorStops: {
              type: Array,
              default: [25, 100, 100, 100],
            },
          },
          image: {
            src: Array,
            width: undefined, // optional
            height: undefined, //optional
          },
          pattern: {
            style: {
              type: String,
              default: 'verticalLines',
            },
            width: { type: Number, default: 6 },
            height: { type: Number, default: 6 },
            strokeWidth: { type: Number, default: 2 },
          },
          colors: {
            type: Array,
            default: ['#50a5f1'],
          },
        },
        xaxis: {
          type: Object,
          default: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          },
        },
        markers: {
          type: Object,
          default: {
            size: 3,
            strokeWidth: 3,

            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
        },
        legend: {
          type: Object,
          default: {
            position: 'top',
            horizontalAlign: 'right',
          },
        },
        tooltip: {
          fixed: {
            enabled: {
              Type: Boolean,
              default: false,
            },
          },
          x: {
            show: {
              Type: Boolean,
              default: false,
            },
          },
          marker: {
            show: {
              Type: Boolean,
              default: false,
            },
            size: {
              Type: Number,
              default: 1,
            },
          },
        },
      },
      plotOptions: {
        area: {
          fillTo: {
            //hashie zire nemodar
            type: String,
            default: 'origin', // 'end'
          },
        },
        bar: {
          horizontal: {
            type: Boolean,
            default: false,
          },
          s̶t̶a̶r̶t̶i̶n̶g̶S̶h̶a̶p̶e̶: {
            type: String,
            default: 'flat',
          },
          e̶n̶d̶i̶n̶g̶S̶h̶a̶p̶e̶: {
            type: String,
            default: 'flat',
          },
          borderRadius: {
            type: Number,
            default: 0,
          },
          columnWidth: {
            type: String,
            default: '70%',
          },
          barHeight: {
            type: String,
            default: '70%',
          },
          distributed: {
            type: Boolean,
            default: false,
          },
          rangeBarOverlap: {
            type: Boolean,
            default: true,
          },
          rangeBarGroupRows: {
            type: Boolean,
            default: false,
          },
          colors: {
            ranges: [
              {
                from: {
                  type: Number,
                  default: 0,
                },
                to: {
                  type: Number,
                  default: 0,
                },
                color: undefined,
              },
            ],
            backgroundBarColors: [],
            backgroundBarOpacity: {
              type: Number,
              default: 1,
            },
            backgroundBarRadius: {
              type: Number,
              default: 0,
            },
          },
          dataLabels: {
            position: 'top',
            maxItems: {
              type: Number,
              default: 100,
            },
            hideOverflowingLabels: {
              type: Boolean,
              default: true,
            },
            orientation: 'horizontal',
          },
        },
      },
    },
  },
}
</script>
<style lang="scss" scoped></style>
